define('specific/filtermanager/views/FilterManagerView', [
    'specific/filtermanager/templates/filtermanager',
    'components/factory/Factory'
], function(tpl, Factory) {

    var FilterManagerView = Mazarine.View.extend({

        events: {
            'click .maz-filter': 'onFilterClick',
            'click .maz-filters-title': 'onTrendTitleClick'
        },

        template: tpl,

        className: 'maz-filtermanager-view',

        initialize: function() {
            Mazarine.View.prototype.initialize.call(this);

            this.listenTo( this.model, 'change:currentFilterId', this.onCurrentFilterChanged );
        },

        onCurrentFilterChanged: function() {
            var obj = this.model.toJSON();

            this.$('.maz-filter').removeClass('maz-selected');

            _.each(obj.filters, function( filter ) {
                if( _.contains( obj.currentFilterId, filter.id ) ) {
                    this.$('.maz-filter[data-id="' + filter.id + '"]').addClass('maz-selected');
                }
            });
        },

        afterRender: function() {
            this.model.set('isReady', true);
            this.onCurrentFilterChanged();
        },

        onFilterClick: function( e ) {
            var filterId        = $(e.currentTarget).attr('data-id'),
                tmp             = new Immutable.List();

            if( this.model.get('allowMultipleSelect') ) {
                tmp = new Immutable.List( this.model.get('currentFilterId') );

                var index = tmp.indexOf(filterId);

                if (index !== -1) {
                    currentFilterId = tmp.splice(index, 1);
                } else {
                    currentFilterId = tmp.push( filterId );
                }
            } else {
                currentFilterId = tmp.push( filterId );
            }

            this.model.set( 'currentFilterId', currentFilterId.toArray() );
        },

        onTrendTitleClick: function() {
            if (window.innerWidth < 1024) {
                var mazFiltersContent = $('.maz-filters-content'),
                    mazFilterList     = $('.maz-filters-list');

                if ( mazFiltersContent.hasClass('open') ) {
                    mazFiltersContent.removeClass('open');

                    TweenLite.to(mazFilterList, 0.6, {
                        height: 0
                    });
                } else {
                    mazFiltersContent.addClass('open');

                    TweenLite.set(mazFilterList, { height: 'auto' });
                    TweenLite.from(mazFilterList, 0.6, {
                        height: 0
                    });
                }
            }
        }
    });

    return FilterManagerView;
});
